<script setup lang="ts">
defineProps<{
	globeSize: number
}>()

const hasWbeGl = ref(false)

onMounted(() => {
	hasWbeGl.value = detectWebGl()
})

function detectWebGl(): boolean {
	let supported: boolean

	try {
		const canvas: HTMLCanvasElement = document.createElement("canvas")
		supported = !!window.WebGLRenderingContext && !!(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"))
	}
	catch {
		supported = false
	}

	try {
		// Using 'let' to rule out some old browsers/devices with potentially buggy implementations
		// eslint-disable-next-line no-eval
		eval("let foo = 123;")
	}
	catch {
		supported = false
	}

	return supported
}
</script>

<template>
	<div
		data-aos="fade-up"
		class="relative min-h-80 border-2 border-foreground rounded-3xl backdrop-blur-8 md:min-h-120">
		<div class="flex flex-col gap-2 p-6">
			<h3 class="text-xl">
				دسترسی در هر پلتفرم
			</h3>

			<p class="text-foreground/60">
				در هر پلتفرمی که دوست دارید با هوش مصنوعی کار کنید
			</p>
		</div>

		<ClientOnly>
			<Globe
				v-if="hasWbeGl"
				:size="globeSize" />

			<NuxtImg
				v-else
				loading="lazy"
				src="/website/feature-platform.svg"
				width="400"
				fit="inside"
				height="291"
				class="start-0 bottom-0 mx-auto block" />
		</ClientOnly>

		<NuxtImg
			loading="lazy"
			src="/website/pwa-icon.svg"
			width="61"
			height="50"
			class="absolute end-3 bottom-3 mt-12" />
	</div>
</template>
